<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_content" class="app-content flex-column-fluid">
  <!--begin::Content container-->
  <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div
      id="kt_app_toolbar_container"
      class="app-container container-fluid d-flex flex-stack"
    >
      <!--begin::Page title-->
      <div
        class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
      >
        <!--begin::Title-->
        <div class="d-flex align-items-center">
          <h1 class="page-heading">
            <svg
              width="30"
              height="31"
              viewBox="0 0 30 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_138_53)">
                <path
                  d="M8.93572 6.21891L4.29275 3.10518C4.23449 3.06604 4.16094 3.06357 4.10021 3.09527C4.03752 3.12846 4 3.19236 4 3.2627V8.92349C4 8.9864 4.03209 9.04485 4.08343 9.07854L8.7274 12.1943C8.758 12.2146 8.79601 12.226 8.83156 12.226C8.86217 12.226 8.89277 12.219 8.92042 12.2037C8.98164 12.17 9.02063 12.1061 9.02063 12.0367V6.37643C9.01915 6.31352 8.98855 6.25408 8.93572 6.21891Z"
                  fill="#265D91"
                />
                <path
                  d="M14.5163 16.9783L9.87331 13.8646C9.81506 13.8259 9.7415 13.8215 9.68078 13.8552C9.61957 13.8869 9.58057 13.9503 9.58057 14.0206V19.6829C9.58057 19.7458 9.61265 19.8042 9.664 19.8389L14.308 22.9541C14.3386 22.9744 14.3766 22.9853 14.4121 22.9853C14.4427 22.9853 14.4733 22.9769 14.501 22.9631C14.5622 22.9299 14.5997 22.866 14.5997 22.7961V17.1358C14.5997 17.0734 14.5691 17.013 14.5163 16.9783Z"
                  fill="#265D91"
                />
                <path
                  d="M25.6627 3.50144C25.6029 3.46825 25.5308 3.46973 25.4726 3.50441L20.8281 6.3358C20.7728 6.36998 20.7383 6.4314 20.7383 6.49679V12.4424C20.7383 12.5118 20.7768 12.5757 20.838 12.6069C20.8656 12.6222 20.8963 12.6301 20.9269 12.6301C20.9629 12.6301 21.0004 12.6197 21.0305 12.5989L25.675 9.48372C25.7263 9.44904 25.7584 9.39059 25.7584 9.32669V3.66589C25.7584 3.59704 25.7219 3.53463 25.6627 3.50144Z"
                  fill="#265D91"
                />
                <path
                  d="M14.1867 2.78963C14.1882 2.72177 14.1531 2.65737 14.0939 2.6227L9.73624 0.0265969C9.68243 -0.00708651 9.6143 -0.00807717 9.55704 0.0196621L4.69684 2.4414C4.63563 2.47261 4.59564 2.53403 4.59268 2.60189C4.58823 2.66827 4.6218 2.73415 4.67858 2.76982L9.0219 5.54275C9.0525 5.56207 9.08706 5.57248 9.1231 5.57248C9.15222 5.57248 9.18283 5.56504 9.21048 5.55018L14.0865 2.95309C14.1462 2.9199 14.1852 2.857 14.1867 2.78963Z"
                  fill="#265D91"
                />
                <path
                  d="M25.2596 2.99965C25.2581 2.93129 25.2211 2.86789 25.1599 2.83668L20.5707 0.379774C20.5154 0.350053 20.4488 0.350054 20.3935 0.38126L15.8487 2.85105C15.789 2.88374 15.7505 2.94665 15.7505 3.01699C15.7505 3.08485 15.7875 3.14925 15.8472 3.18243L20.4616 5.76566C20.4907 5.78101 20.5223 5.78943 20.5529 5.78943C20.586 5.78943 20.6181 5.78101 20.6472 5.76417L25.1653 3.16708C25.2255 3.13191 25.2611 3.069 25.2596 2.99965Z"
                  fill="#265D91"
                />
                <path
                  d="M20.0772 13.8551C20.0164 13.8215 19.9429 13.8254 19.8841 13.8645L15.2417 16.9783C15.1888 17.0135 15.1567 17.0734 15.1567 17.1358V22.7966C15.1567 22.8664 15.1957 22.9303 15.2565 22.9635C15.2846 22.9774 15.3147 22.9863 15.3453 22.9863C15.3819 22.9863 15.4189 22.9744 15.4495 22.9546L20.0939 19.8394C20.1453 19.8047 20.1774 19.7463 20.1774 19.6834V14.0216C20.1774 13.9512 20.1384 13.8873 20.0772 13.8551Z"
                  fill="#265D91"
                />
                <path
                  d="M19.7028 13.3603C19.7042 13.2924 19.6692 13.228 19.6099 13.1934L15.0845 10.2718C15.0306 10.2391 14.9625 10.2376 14.9057 10.2654L9.99273 13.1364C9.93201 13.1676 9.89153 13.229 9.88906 13.2969C9.88462 13.3638 9.91819 13.4292 9.97496 13.4653L14.7172 16.5815C14.7478 16.6008 14.7818 16.6108 14.8184 16.6108C14.8475 16.6108 14.8781 16.6038 14.9057 16.5885L19.6025 13.5233C19.6623 13.4911 19.7013 13.4282 19.7028 13.3603Z"
                  fill="#265D91"
                />
                <path
                  d="M14.6466 3.50144C14.5869 3.46825 14.5148 3.46973 14.4566 3.50441L9.66993 6.08862C9.61464 6.1228 9.58008 6.18373 9.58008 6.24961V12.1952C9.58008 12.2646 9.61859 12.3285 9.6798 12.3602C9.70745 12.375 9.73805 12.383 9.76866 12.383C9.8047 12.383 9.84173 12.3726 9.87233 12.3518L14.7538 9.68631C14.8051 9.65164 14.8372 9.59319 14.8372 9.52879L14.7429 3.66589C14.7429 3.59704 14.7069 3.53463 14.6466 3.50144Z"
                  fill="#265D91"
                />
                <path
                  d="M20.1305 6.18869L15.4885 3.46528C15.4303 3.42664 15.3572 3.42169 15.296 3.45537C15.2348 3.48757 15.1963 3.55098 15.1963 3.62082L15.2481 9.49263C15.2481 9.55554 15.2802 9.6135 15.3311 9.64817L19.98 12.4949C20.0106 12.5152 20.0486 12.5266 20.0841 12.5266C20.1147 12.5266 20.1453 12.5177 20.173 12.5043C20.2342 12.4706 20.2717 12.4072 20.2717 12.3369V6.46757C20.2717 6.40466 20.1834 6.22287 20.1305 6.18869Z"
                  fill="#265D91"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_138_53"
                  x="0"
                  y="0"
                  width="29.7583"
                  height="30.9863"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_138_53"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_138_53"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>

            Fournisseur
          </h1>
        </div>
        <!--end::Title-->
        <!--begin::Breadcrumb-->
        <ul
          class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
        >
          <!--begin::Item-->
          <li class="breadcrumb-item text-muted">
            <a class="text-muted" routerLink="/">Accueil</a>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li class="breadcrumb-item">
            <span class="bullet bg-gray-400 w-5px h-2px"></span>
          </li>
          <!--end::Item-->
          <!--begin::Item-->
          <li class="breadcrumb-item text-muted">
            <a routerLink="/fournisseurs" class="text-muted"
              >Liste fournisseurs
            </a>
          </li>
          <li class="breadcrumb-item">
            <span class="bullet bg-gray-400 w-5px h-2px"></span>
          </li>

          <li class="breadcrumb-item text-muted">Détail fournisseur</li>

          <!--end::Item-->
        </ul>
        <!--end::Breadcrumb-->
      </div>
      <!--end::Page title-->
      <!--begin::Actions-->

      <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
  </div>
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="card mb-10">
      <div class="header-page">
        <div class="title">
          <h4>fournisseur: </h4> <span>{{esnDetails?.name}}({{type}})</span>
           
        </div>
        <div class="edit cursor-pointer" >
          <a
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Voir dossier des compétences"
            (click)="navigateToProfile()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="29"
              viewBox="0 0 32 29"
              fill="none"
            >
              <g filter="url(#filter0_d_126_262)">
                <path
                  d="M21.795 7.11531C19.8257 7.11531 18.2199 5.51738 18.2199 3.55766C18.2199 1.59793 19.8257 0 21.795 0C23.7643 0 25.3701 1.59793 25.3701 3.55766C25.3701 5.51738 23.7643 7.11531 21.795 7.11531ZM16.3112 4.58274C16.3112 2.05017 14.2509 0.0301492 11.7363 0.0301492C9.19127 0.0301492 7.16135 2.08032 7.16135 4.58274C7.16135 7.11531 9.22157 9.13533 11.7363 9.13533C14.2812 9.13533 16.3112 7.08516 16.3112 4.58274ZM27.0667 15.9491C27.5212 15.9491 27.8848 15.5572 27.8242 15.105C27.3394 11.6076 25.8245 8.1404 21.795 8.1404C19.5227 8.1404 18.0381 9.25593 17.0989 10.8539C17.7654 11.4267 18.3714 12.09 18.8561 12.904C19.4015 13.7784 19.8863 14.8035 20.2498 15.9793H27.0667V15.9491ZM4.01041 19.2053C3.91952 19.8686 4.43457 20.5017 5.13142 20.5017H18.3411C19.0379 20.5017 19.553 19.8987 19.4621 19.2053C18.7956 14.8035 16.8565 10.4619 11.7363 10.4619C6.61599 10.4619 4.67695 14.8035 4.01041 19.2053Z"
                  fill="#265D91"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_126_262"
                  x="0"
                  y="0"
                  width="31.8311"
                  height="28.5017"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_126_262"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_126_262"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </a>
        </div>
      </div>
      <!--begin::Card header-->

      <!--end::Card header-->
      <!--begin::Card body-->
      <div class="card-body pt-0" [formGroup]="companyDetailsForm" >
        <div class="container search-bar">
          <div class="symbol symbol-150px symbol-circle mb-7">
            <!-- <img
              class="table-img logo-img"
              src="{{
                esnDetails?.logo
                  ? url_image  + esnDetails.logo
                  : '/assets/media/icons/avatar.jpg'
              }}"
              alt=""
            /> -->
            <img  class="table-img logo-img"
                                src="{{url+'/Company/file/gallery_company/'+  esnDetails?.logo}}"
                                alt="">
                            <!-- <img *ngIf="! esnDetails?.logo" class="table-img logo-img"
                                src="/assets/media/icons/avatar.jpg" alt=""> -->
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="required "
                  >Nom </label
                >
                <input
                  formControlName="name"
                  type="text"
                  class="form-control"
                  placeholder="Nom"
                />
              </div>
            </div>
         
           
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="required ">Linkedin</label>
                <input
                  formControlName="linkedin_link"
                  type="text"
                  class="form-control"
                  placeholder="Entrez votre lien LinkedIn (ex. https://www.linkedin.com/in/votreprofil)"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="required ">Site web</label>
                <input type="text" name="website_link" id="website_link" class="form-control"
                placeholder=" https://www.exemple.com ou www.exemple.fr"
                formControlName="website_link" >
              </div>
            </div>
           
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" >Pays </label>
                <ng-select (change)="onCountryChange($event)" [items]="paysList" [notFoundText]="'Aucun élément trouvé'"
                formControlName="country" bindLabel="name" bindValue="name" [placeholder]="'Pays'" autoComplete>
              </ng-select>

              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" >Emplacement </label>
                <ng-select [items]="stateList" bindLabel="name" formControlName="address"
                [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'
              Emplacement'" autoComplete>
              </ng-select>

              </div>
            </div>

          <div class="col-lg-6">
            <div class="mb-10 calendar-year">
              <label for="creation">Année de création </label><i class="fa fa-calendar"></i>
              <br>
              <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" view="year" dateFormat="yy"
                placeholder="Année" inputId="yearpicker" formControlName="year_of_creation" class="form-control"></p-calendar>
            </div>
            </div>
          
           <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" 
                  >Nom Vis à vis
                </label>
                <input type="text" id="Nom" class="form-control mb-3" placeholder="Nom Vis à vis"
                formControlName="related_first_name_client" />
              </div>
            </div> 
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" 
                  >Prénom Vis à vis
                </label>
                <input type="text" id="Nom" class="form-control mb-3" placeholder="Prénom Vis à vis"
                formControlName="related_last_name_client" />
              </div>
            </div> 
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" 
                  >Contact Email vis à vis
                </label>
                <input type="email" id="Prénom" class="form-control mb-3" placeholder="adresse@gmail.com"
                formControlName="related_email_client" />
              </div>
            </div> 
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" 
                  >Téléphone vis à vis
                </label>
                <div class="wrapper ">
                  <ngx-intl-tel-input [cssClass]="'form-control'"   [preferredCountries]="preferredCountries"
                    [searchCountryPlaceholder]="'Rechercher un pays'"
                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France" [maxLength]="20"
                    [phoneValidation]="true" [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="related_phone_client">
                  </ngx-intl-tel-input>

                </div>
              </div>
            </div> 
            <!-- <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" 
                  >Nombre total des jours de prestation jusqu'au le mois dernier
                </label>
                <input
                  type="text"
                  formControlName="nb_days"
                  class="form-control"
                  placeholder="le nombre de jours de prestation du mois dernier
                  "
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" 
                  >Date de la première prestation
                </label>
                <input
                  type="text"
                  formControlName="date_first_presentation"
                  class="form-control"
                  placeholder="le nombre de jours de prestation du mois dernier
                  "
                />
              </div>
            </div> -->
           
          </div>
        </div>
      </div>
      <div class="card-body pt-0" [formGroup]="supplierDetailsForm" *ngIf="type === 'fournisseur'">
        <!--begin::Table-->
        <div class="container search-bar">
          <div class="symbol symbol-150px symbol-circle mb-7">
            <!-- <img
              class="table-img logo-img"
              src="{{
                esnDetails?.logo
                  ? url_image  + avatar
                  : '/assets/media/icons/avatar.jpg'
              }}"
              alt=""
            /> -->
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="required form-label"
                  >Nom Fournisseur</label
                >
                <input
                  formControlName="fournisseur_first_name"
                  type="text"
                  class="form-control"
                  placeholder="Nom"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="required form-label"
                  >Prénom Fournisseur
                </label>
                <input
                  formControlName="fournisseur_last_name"
                  type="text"
                  class="form-control"
                  placeholder="Prénom Fournisseur"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="required form-label"
                  >Email personel
                </label>
                <input
                  formControlName="fournisseur_email"
                  type="text"
                  class="form-control"
                  placeholder="adresse@gmail.com"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="required form-label">Linkedin</label>
                <input
                  formControlName="linkedin_link"
                  type="text"
                  class="form-control"
                  placeholder="Entrez votre lien LinkedIn (ex. https://www.linkedin.com/in/votreprofil)"
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="form-label">Téléphone </label>
                <!-- <input
                  formControlName="fournisseurPhone"
                  type="text"
                  class="form-control"
                  placeholder="Téléphone"
                /> -->
                <div class="wrapper  phone-number">
                <ngx-intl-tel-input [cssClass]="'form-control'"   [preferredCountries]="preferredCountries"
                    [searchCountryPlaceholder]="'Rechercher un pays'"
                [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France" [maxLength]="20"
                [phoneValidation]="true" [separateDialCode]="separateDialCode"
                [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="fournisseurPhone" >
              </ngx-intl-tel-input>
            </div>
              </div>
            </div>

        
            <!-- <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="form-label"
                  >nombre total des jours de prestation jusqu'au le mois dernier
                </label>
                <input
                  type="text"
                  formControlName="linkedin_link"
                  class="form-control"
                  placeholder="le nombre de jours de prestation du mois dernier
                  "
                />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="mb-10">
                <label for="id" class="form-label"
                  >Date de la première prestation
                </label>
                <input
                  type="text"
                  formControlName="linkedin_link"
                  class="form-control"
                  placeholder="le nombre de jours de prestation du mois dernier
                  "
                />
              </div>
            </div> -->
            <!-- <div class="save-btn mt-5 confirmer">
                              <button  class="btn save" [disabled]="fileExtention || fileError || !esnForm.valid" (click)="updateCunsultant()">Consultant:</button>
                          </div> -->
          </div>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Card body-->
    </div>
  </div>
  <!--end::Content container-->
</div>
<!-- <div id="kt_app_content" class="app-content flex-column-fluid">

  <div id="kt_app_content_container" class="app-container container-fluid">

    <div class="d-flex flex-column flex-xl-row block1">

      <div class="flex-column flex-lg-row-auto w-100 w-xl-500px mb-10">

        <div class="card-wrap mb-5 mb-xl-8">


          <div class="card-body pt-15 position-relative" *ngIf="esnDetails">

            <div class="d-flex flex-center flex-column mb-5">

              <div class="symbol symbol-150px symbol-circle mb-7">
                 <img
                  *ngIf="esnDetails?.logo"
                  class="table-img logo-img"
                  src="{{
                    url + '/Company/file/gallery_company/' + esnDetails.logo
                  }}"
                  alt=""
                /> 
                <img
                  *ngIf="!esnDetails?.logo"
                  class="table-img logo-img"
                  src="/assets/media/icons/avatar.jpg"
                  alt=""
                />
              </div>
             
              
              <a class="title-esn text-center mb-1">
                <p>{{ esnDetails.name }}</p>
                <span *ngIf="esnDetails.type == '2'">ESN </span>
                <span *ngIf="esnDetails.type == '5'">Individuel </span>
              </a>

              
            </div>
          
            
            <div class="py-3 text-center title-bg">
              <div class="contact">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 50 50"
                  width="20px"
                  height="20px"
                >
                  <path
                    d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z"
                    fill="#265D91"
                  />
                </svg>
                Détails
              </div>
           
              
            </div>
           
            
            <div class="contact-info pb-5 fs-6">

              <div class="flex-space">
                <div class="contact-info-name">Nom</div>
                <div class="text-gray-600">
                  {{ esnDetails?.name ? esnDetails.name : "---" }}
                </div>
              </div>

              <div class="flex-space">
                <div class="contact-info-name">Prénom</div>
                <div class="text-gray-600">
                  <span>{{
                    esnDetails?.last_name ? esnDetails.last_name : "---"
                  }}</span>
                </div>
              </div>

              <div class="flex-space">
                <div class="contact-info-name">Email</div>
                <div class="text-gray-600">
                  {{
                    esnDetails?.ContactEmail &&
                    esnDetails?.ContactEmail !== "null"
                      ? esnDetails.ContactEmail
                      : "---"
                  }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Nombre des consultants</div>
                <div class="text-gray-600">
                  {{
                    esnDetails?.number_of_consultant
                      ? esnDetails?.number_of_consultant
                      : "---"
                  }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Nombre jours de préstation</div>
                <div class="text-gray-600">
                  {{ esnDetails?.nb_days ? esnDetails?.nb_days : "---" }}
                </div>
              </div>

              <div class="flex-space">
                <div class="contact-info-name">Domaine</div>

                <div class="text-gray-600">
                  {{ esnDetails?.domain ? esnDetails?.domain : "---" }}
                </div>
              </div>

              <div class="flex-space">
                <div class="contact-info-name">Nombre des salariés</div>
                <div class="text-gray-600">
                  {{
                    esnDetails?.number_of_salaries
                      ? esnDetails?.number_of_salaries
                      : "---"
                  }}
                </div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">Année de création</div>
                <div class="text-gray-600">
                  {{
                    esnDetails?.year_of_creation
                      ? esnDetails?.year_of_creation
                      : "---"
                  }}
                </div>
              </div>

              <div class="flex-space">
                <div class="contact-info-name">
                  le nombre de jours de prestation du mois dernier
                </div>
                <div class="text-gray-600">21 jours</div>
              </div>
              <div class="flex-space">
                <div class="contact-info-name">LinkedIn</div>
                <div class="text-gray-600">
                  {{
                    esnDetails.linkedin_link ? esnDetails.linkedin_link : "---"
                  }}
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="flex-lg-row-fluid">
        <div class="card card-right pt-4 mb-6 mb-xl-9">
          <div class="card-header border-0">
            <div class="card-title flex-column">
              <h2 class="mb-1">
                <svg
                  width="34"
                  height="40"
                  viewBox="0 0 34 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_126_200)">
                    <mask
                      id="mask0_126_200"
                      style="mask-type: luminance"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="34"
                      height="34"
                    >
                      <path d="M33.1272 0H0V33.2H33.1272V0Z" fill="white" />
                    </mask>
                    <g mask="url(#mask0_126_200)">
                      <path
                        d="M12.423 2.07499C11.131 2.07499 10.1477 2.07046 9.3194 2.16415C8.49111 2.25783 7.73291 2.46482 7.16602 3.03346C6.59921 3.60209 6.39364 4.36177 6.30064 5.19156C6.2078 6.01983 6.21166 7.00397 6.21167 8.29389C6.21167 8.29457 6.21167 8.29524 6.21167 8.29592V8.29997V20.7541C6.21148 23.1225 6.0608 24.5238 6.90722 25.7106C7.33069 26.3044 8.01481 26.6431 8.71679 26.7906C9.20428 26.893 9.76589 26.927 10.3808 26.9466C10.3936 27.3216 10.4054 27.6905 10.4415 28.0105C10.535 28.8407 10.7414 29.6025 11.3089 30.1706C11.8763 30.7386 12.6344 30.9427 13.4622 31.0358C14.2901 31.1289 15.2734 31.125 16.5639 31.125H22.7025C22.7267 31.1265 22.751 31.1272 22.7752 31.127C24.0658 31.127 25.049 31.1311 25.8769 31.0378C26.7047 30.9446 27.4628 30.7386 28.0303 30.1706C28.5976 29.6025 28.8042 28.8427 28.8977 28.0125C28.9911 27.1828 28.9866 26.1957 28.9866 24.902V12.45C28.9869 12.4046 28.9842 12.3592 28.9785 12.3142C28.9784 11.5259 28.9721 10.8971 28.653 10.2574C28.3144 9.57859 27.8098 9.11651 26.9546 8.25943C26.0993 7.40172 25.6447 6.89802 24.9671 6.55731C24.8557 6.50129 24.7446 6.46636 24.6335 6.42762C24.5207 6.11863 24.3632 5.81855 24.1603 5.55223C23.8329 5.12229 23.4209 4.71792 22.8137 4.10948C21.9584 3.25177 21.5038 2.74808 20.8262 2.40736C20.1696 2.07726 19.5284 2.0769 18.7032 2.07706C18.6789 2.07553 18.6546 2.07486 18.6304 2.07504L12.423 2.07499ZM12.423 4.14999H17.5991V6.22499H16.5639C15.2719 6.22499 14.2886 6.22046 13.4603 6.31415C12.632 6.40783 11.8738 6.61482 11.3069 7.18346C10.7401 7.75209 10.5345 8.51177 10.4415 9.34156C10.3487 10.1698 10.3526 11.154 10.3526 12.4439C10.3526 12.4446 10.3526 12.4452 10.3526 12.4459V12.45V24.8699C9.84479 24.8488 9.41116 24.8171 9.14146 24.7605C8.72636 24.6733 8.66662 24.6084 8.5915 24.5031C8.44136 24.2926 8.28235 23.1205 8.28214 20.7543V8.29601C8.28216 7.00577 8.28869 6.04972 8.35898 5.42265C8.42935 4.79485 8.54842 4.5824 8.62992 4.50066C8.7114 4.41891 8.92543 4.29795 9.55191 4.2271C10.1784 4.15624 11.1321 4.14999 12.423 4.14999ZM19.6696 4.20672C19.7466 4.22271 19.8398 4.23318 19.896 4.26144C20.0856 4.35673 20.4949 4.71725 21.3498 5.5745C21.3498 5.57517 21.3498 5.57585 21.3498 5.57652C21.6681 5.89554 21.7638 6.01705 21.9604 6.22496H19.6696L19.6696 4.20672ZM16.5639 8.29997H21.74V12.45C21.7401 13.0229 22.2035 13.4874 22.7752 13.4875H26.9161V24.902V24.9041C26.9161 26.1967 26.91 27.152 26.8393 27.7795C26.7686 28.4074 26.6479 28.6198 26.5664 28.7015C26.4848 28.7832 26.2728 28.9045 25.6464 28.9751C25.0327 29.0441 24.0941 29.0518 22.844 29.0521C22.8198 29.0505 22.7955 29.0499 22.7712 29.05H16.5639C15.2741 29.05 14.3193 29.0455 13.6928 28.9751C13.0664 28.9046 12.8544 28.7831 12.7729 28.7015C12.6914 28.6199 12.5706 28.4074 12.4999 27.7795C12.4293 27.1524 12.4231 26.1958 12.4231 24.9041V12.4499V12.4459C12.4231 11.1556 12.4296 10.1996 12.4999 9.57252C12.5703 8.94471 12.6894 8.73226 12.7708 8.65052C12.8523 8.56877 13.0664 8.44781 13.6928 8.37696C14.3193 8.30611 15.273 8.29997 16.5639 8.29997ZM23.8105 8.35671C23.8875 8.37269 23.9807 8.38317 24.0369 8.41142C24.2265 8.50672 24.6358 8.86724 25.4907 9.72448C25.4907 9.72516 25.4907 9.72583 25.4907 9.72651C26.3448 10.5824 26.7049 10.991 26.8009 11.1835C26.8294 11.2407 26.8395 11.3344 26.8555 11.4124H23.8105L23.8105 8.35671Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 20.7543C15.3894 20.7523 15.2532 20.7777 15.1259 20.829C14.9986 20.8802 14.8827 20.9564 14.785 21.0529C14.6873 21.1494 14.6097 21.2645 14.5568 21.3913C14.5038 21.5181 14.4766 21.6543 14.4766 21.7918C14.4766 21.9292 14.5038 22.0654 14.5568 22.1922C14.6097 22.3191 14.6873 22.4341 14.785 22.5306C14.8827 22.6272 14.9986 22.7033 15.1259 22.7545C15.2532 22.8058 15.3894 22.8312 15.5265 22.8293H23.8104C23.9476 22.8312 24.0838 22.8058 24.2111 22.7545C24.3384 22.7033 24.4542 22.6272 24.5519 22.5306C24.6496 22.4341 24.7272 22.3191 24.7802 22.1922C24.8331 22.0654 24.8604 21.9292 24.8604 21.7918C24.8604 21.6543 24.8331 21.5181 24.7802 21.3913C24.7272 21.2645 24.6496 21.1494 24.5519 21.0529C24.4542 20.9564 24.3384 20.8802 24.2111 20.829C24.0838 20.7777 23.9476 20.7523 23.8104 20.7543H15.5265Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 16.6041C15.3894 16.6022 15.2532 16.6276 15.1259 16.6788C14.9986 16.7301 14.8827 16.8062 14.785 16.9027C14.6873 16.9993 14.6097 17.1143 14.5568 17.2411C14.5038 17.368 14.4766 17.5041 14.4766 17.6416C14.4766 17.7791 14.5038 17.9152 14.5568 18.0421C14.6097 18.1689 14.6873 18.2839 14.785 18.3805C14.8827 18.477 14.9986 18.5531 15.1259 18.6044C15.2532 18.6557 15.3894 18.6811 15.5265 18.6791H23.8104C23.9476 18.6811 24.0838 18.6557 24.2111 18.6044C24.3384 18.5531 24.4542 18.477 24.5519 18.3805C24.6496 18.2839 24.7272 18.1689 24.7802 18.0421C24.8331 17.9152 24.8604 17.7791 24.8604 17.6416C24.8604 17.5041 24.8331 17.368 24.7802 17.2411C24.7272 17.1143 24.6496 16.9993 24.5519 16.9027C24.4542 16.8062 24.3384 16.7301 24.2111 16.6788C24.0838 16.6276 23.9476 16.6022 23.8104 16.6041H15.5265Z"
                        fill="#265D91"
                      />
                      <path
                        d="M15.5265 24.9042C15.3894 24.9022 15.2532 24.9276 15.1259 24.9789C14.9986 25.0301 14.8827 25.1063 14.785 25.2028C14.6873 25.2993 14.6097 25.4144 14.5568 25.5412C14.5038 25.668 14.4766 25.8042 14.4766 25.9417C14.4766 26.0792 14.5038 26.2153 14.5568 26.3421C14.6097 26.469 14.6873 26.584 14.785 26.6805C14.8827 26.7771 14.9986 26.8532 15.1259 26.9044C15.2532 26.9557 15.3894 26.9811 15.5265 26.9792H23.8104C23.9476 26.9811 24.0838 26.9557 24.2111 26.9044C24.3384 26.8532 24.4542 26.7771 24.5519 26.6805C24.6496 26.584 24.7272 26.469 24.7802 26.3421C24.8331 26.2153 24.8604 26.0792 24.8604 25.9417C24.8604 25.8042 24.8331 25.668 24.7802 25.5412C24.7272 25.4144 24.6496 25.2993 24.5519 25.2028C24.4542 25.1063 24.3384 25.0301 24.2111 24.9789C24.0838 24.9276 23.9476 24.9022 23.8104 24.9042H15.5265Z"
                        fill="#265D91"
                      />
                    </g>
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_126_200"
                      x="2.20117"
                      y="2.07495"
                      width="30.7852"
                      height="37.052"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_126_200"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_126_200"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
                Description
              </h2>
            </div>
           
          </div>
          
        </div>
        <div class="content">
          <div class="row descri mb-4 p-5">
            <p>zaerzrre</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
